import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnsiteImplementationService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/onsiteimplementation`;

  constructor(private http: HttpClient) {}

  getImplementationSummary(taskId: number): Observable<Boo.Objects.OnsiteImplementation.OnsiteImplementationSummary> {
    const params = new HttpParams().set('taskId', taskId);

    return this.http.get<Boo.Objects.OnsiteImplementation.OnsiteImplementationSummary>(`${this.baseUrl}/ImplementationSummary`, { params: params });
  }
}
